angular.module('leanlaw').filter("orderByColumn", [function () {
  return function (rows, sort, reverse) {
    if (!rows || !sort) return rows;
    return rows.slice().sort((a, b) => {
      const aValue = a.values[sort].value;
      const bValue = b.values[sort].value;
      if (typeof aValue === 'string' || typeof bValue === 'string') {
        // If one column has an id and the other doesn't, we will favor the one with an id
        // (This is for the practice area reports, where the "no practice area" should always be last)
        if (a.id && !b.id) return -1;
        if (!a.id && b.id) return 1;

        // If the column is a string, we'll sort it with localeCompare
        return reverse ? stringCompare(bValue, aValue) : stringCompare(aValue, bValue);
      }

      // Columns are sorted a numbers
      if (aValue < bValue) return reverse ? 1 : -1;
      if (aValue > bValue) return reverse ? -1 : 1;
      return 0;
    });
  };
  function stringCompare(a, b) {
    if (!a) return 1;
    if (!b) return -1;
    return a.localeCompare(b);
  }
}]);